import { Invoice } from 'types'

const isOverdue = (invoice: Invoice, today: string): boolean =>
  !!invoice.deadline &&
  invoice.finalized &&
  invoice.deadline < today &&
  !invoice.paid

export default isOverdue
